/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridDataCommittingEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridDataCommittingEventArgs, _super);
    function GridDataCommittingEventArgs(a, b) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.b = 0;
        _this.b = a;
        _this.a = b;
        return _this;
    }
    GridDataCommittingEventArgs.$t = markType(GridDataCommittingEventArgs, 'GridDataCommittingEventArgs');
    return GridDataCommittingEventArgs;
}(Base));
export { GridDataCommittingEventArgs };
//# sourceMappingURL=GridDataCommittingEventArgs.js.map
